import React from "react";

export default function MarketTicker() {
  // TradingView Ticker Config
  const config = {
    symbols: [
      { proName: "FOREXCOM:EURUSD", title: "EUR/USD" },
      { proName: "FOREXCOM:USDINR", title: "USD/INR" },
      { proName: "NASDAQ:AAPL", title: "AAPL" },
      { proName: "NASDAQ:TSLA", title: "TSLA" },
      { proName: "BSE:SENSEX", title: "Sensex" },
      { proName: "NSE:NIFTY", title: "Nifty" },
      { proName: "BINANCE:BTCUSDT", title: "BTC/USDT" },
      { proName: "BINANCE:ETHUSDT", title: "ETH/USDT" },
    ],
    showSymbolLogo: true,
    colorTheme: "dark",
    isTransparent: false,
    displayMode: "adaptive",
    locale: "en"
  };

  const src = `https://s.tradingview.com/embed-widget/ticker-tape/?locale=en#${encodeURIComponent(
    JSON.stringify(config)
  )}`;

  return (
    <div
      className=" w-full  z-20 transition-opacity itemscenter duration-300 bg-[#0A1420] "
      style={{
        minHeight: 44, // a bit less for mobile, more for desktop if you want
        
      }}
    >
      <div className="w-full overflow-x-auto items-center flex ">
        <iframe
          src={src}
          width="100%"
          height="44"
          frameBorder="0"
          title="Live Market Ticker"
          style={{
            display: "block",
            width: "100%",
            minWidth: 320,
            maxWidth: "100vw",
            
            userSelect: "none",
            background: "#0A1420"
          }}
          scrolling="no"
          tabIndex={-1}
          aria-hidden="true"
        />
      </div>
    </div>
  );
}
